export const SET_MODE = 'SET_MODE';
export const SET_STATUS = 'SET_STATUS';
export const SET_OPTIONS = 'SET_OPTIONS';
export const SET_AUTOMATION = 'SET_AUTOMATION';
export const SET_FILTER = 'SET_FILTER';
export const SET_LIST = 'SET_LIST';
export const SET_SELECTED_PERSONFIELDS = 'SET_SELECTED_PERSONFIELDS';
export const SET_SELECTED_ORGFIELDS = 'SET_SELECTED_ORGFIELDS';
export const RESET_STATE = 'RESET_STATE';
